/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { useIntl } from 'react-intl'
import { KTIcon } from '../../../../helpers'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'
import { useAuth } from '../../../../../app/modules/auth'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const {
    auth,
    isAdmin,
    isAuditor,
    isFacilityManager,
    isSupplyChainManager,
    isFranchise,
    isPartner,
    isSponsor,
    currentUser
  }: any = useAuth()


  const isAdminUser = currentUser?.userType === 'ADMIN';
  const isMarketingUser = currentUser?.userType === 'CLIENT_USER' || currentUser?.userType === 'MARKETING';
  // const isAdminUser = currentUser?.userType === 'CLIENT';

  const isDppEnable: any = auth?.data?.enabledFeatures?.includes('DPP') || false
  // const isAdmin = auth?.data?.userType === 'ADMIN'
  // const isPartner = auth?.data?.userType === 'CLIENT'
  // const isFranchise = auth?.data?.userType === 'FRANCHISE'
  // const isAuditor = auth?.data?.userType === 'AUDITOR'

  const sidebarPayoad = [
    {
      title: 'Client',
      route: '/apps/client',
      icon: 'grid-frame',
      fontIcon: '',
      hasBullet: false,
    },
    {
      title: 'Billing',
      route: '/apps/billing',
      icon: 'grid-frame',
      fontIcon: '',
      hasBullet: false,
    },
    {
      title: 'Monthly volume',
      route: '/apps/monthly-volume',
      icon: 'grid-frame',
      fontIcon: '',
      hasBullet: false,
    },
    {
      title: 'Supply chain',
      route: '/apps/franchisee',
      // icon: 'grid-frame',
      icon: '/media/sideBarMenuIcon/supply chain.png'
    },
    // {
    //   title: 'Maketing',
    //   route: '/apps/makting',
    //   // icon: 'grid-frame',
    //   icon: '/media/sideBarMenuIcon/supply chain.png'
    // },


    // {
    //   title: 'User Management',
    //   route: '/apps/user',
    //   // icon: 'switch',
    //   icon: '/media/sideBarMenuIcon/side bar user.png'
    // },
    {
      title: 'User management',
      route: currentUser?.userType === 'CLIENT'
        ? '/apps/client-user-management'
        : '/apps/user',
      icon: '/media/sideBarMenuIcon/side bar user.png'
    },
    {
      title: 'Material Hubs',
      // route: '/apps/facilities',
      route: 'apps/facility',
      // icon: 'maximize',
      icon: '/media/sideBarMenuIcon/Facilities.png',
      // subMenu: [
      //   {
      //     title: 'Facility information',
      //     route: '/apps/facilities/user-information',
      //   },
      //   { title: 'Compliance', route: '/apps/facilities/compilance' },
      //   {
      //     title: 'Processing Capacity',
      //     route: '/apps/facilities/processing-capacity',
      //   },
      // ],
    },
    {
      title: 'Ecosystem',
      route: '/apps/ecosystem',
      icon: '/media/sideBarMenuIcon/sidebar waste supplier.png',
    },
    {
      title: 'Plastic Keepers',
      route: '/apps/waste-source',
      // icon: 'switch',
      icon: '/media/sideBarMenuIcon/sidebar waste supplier.png',
    },
    // ...(currentUser?.userType === 'FRANCHISE_USER' || currentUser?.userType === 'PICKUP_POINT_STAFF' ? [
    ...(currentUser?.userType === 'FRANCHISE_USER' ||
      currentUser?.userType === 'PICKUP_POINT_STAFF' ||
      currentUser?.userType === 'CLIENT' ? [
      {
        // title: 'CRM (New)',
        title: (
          <span>
            CRM
            {/* <span style={{
              backgroundColor: '#dc3545',
              color: 'white',
              fontSize: '10px',
              padding: '2px 6px',
              borderRadius: '4px',
              marginLeft: '8px',
              fontWeight: '500',
              verticalAlign: 'middle'
            }}>
              New
            </span> */}
          </span>
        ),
        route: '/apps/customers',
        // icon: 'switch',
        icon: '/media/sideBarMenuIcon/CRM.png',
      },
    ] : []),
    {
      title: 'Transactions',
      route: '/apps/transactions',
      // icon: 'maximize',
      icon: '/media/sideBarMenuIcon/sidebar transactiobs.png',
    },

    {
      title: 'Settings',
      route: '/apps/settings',
      // icon: 'maximize',
      icon: '/media/sideBarMenuIcon/sidebar settings.png',
    },
    // {
    //   // title: 'Plastic credits',
    //   title: currentUser?.userType === 'FRANCHISE_USER' || currentUser?.userType === 'CLIENT'
    //     ? 'Impact credits'
    //     : 'Plastic credits',
    //   route: '/apps/plastic-credits',
    //   // icon: 'maximize',
    //   icon: '/media/sideBarMenuIcon/icons8-certificate-48.png',
    //   subMenu: [
    //     {
    //       title: 'Unaudited',
    //       route: '/apps/plastic-credits/unaudited',
    //     },
    //     { title: 'Audited', route: '/apps/plastic-credits/audited' },
    //     ...((!isAuditor && [{ title: 'Retired', route: '/apps/plastic-credits/retired' }]) || []),
    //   ],
    // },




    {
      title: currentUser?.userType === 'CLIENT'
        ? 'Impact credits'
        : 'Plastic credits',
      route: '/apps/plastic-credits',
      icon: '/media/sideBarMenuIcon/icons8-certificate-48.png',
      subMenu: [
        {
          title: 'Unaudited',
          route: '/apps/plastic-credits/unaudited',
        },
        { title: 'Audited', route: '/apps/plastic-credits/audited' },
        ...((!isAuditor && [{ title: 'Retired', route: '/apps/plastic-credits/retired' }]) || []),
      ],
    },




    // ...((isDppEnable && [
    //   {
    //     title: 'Product passport',
    //     route: '/apps/product-passport',
    //     // icon: 'maximize',
    //     icon: '/media/sideBarMenuIcon/sidebar product passport.png',
    //   },
    // ]) ||
    //   [] ||
    //   []),

    // ...((isSupplyChainManager && [
    //   {
    //     title: 'Mass Balancer',
    //     route: '/apps/mass-balancer',
    //     // icon: 'maximize',
    //     icon: '/media/sideBarMenuIcon/sidebar mass balance.png',
    //   },
    // ]) ||
    //   []),


    // ...(isSupplyChainManager || isFacilityManager ? [
    //   {
    //     title: 'Mass Balancer',
    //     route: '/apps/mass-balancer',
    //     // icon: 'maximize',
    //     icon: '/media/sideBarMenuIcon/sidebar mass balance.png',
    //   },
    // ] : []),


    // ...(isSupplyChainManager || isFacilityManager ? [
    //   {
    //     // title: isFacilityManager ? 'ISCC' : 'Mass Balancer',
    //     title: 'Mass Balancer',
    //     route: '/apps/mass-balancer',
    //     // icon: 'maximize',
    //     icon: '/media/sideBarMenuIcon/sidebar mass balance.png',
    //   },
    // ] : []),


    //   ...(isFacilityManager ? [
    //     {
    //       title: 'Mass Balancer',
    //       route: '/apps/mass-balancer',
    //       icon: '/media/sideBarMenuIcon/sidebar mass balance.png',
    //     },
    //   ] : []
    // ),




    // {
    //   title: 'ISCC EU',
    //   route: '/apps/iscceu',
    //   // icon: 'maximize',
    //   icon: '/media/sideBarMenuIcon/ISCCEUISCC.png',
    // },

    ...(() => {
      const authData = localStorage.getItem('kt-auth-react-v');
      if (!authData) return [];

      try {
        const parsed = JSON.parse(authData);
        if (parsed?.data?.segmentType === 'BIOFUEL') {
          return [
            {
              title: 'ISCC EU',
              route: '/apps/iscceu',
              icon: '/media/sideBarMenuIcon/ISCCEUISCC.png',
            },
          ];
        }
      } catch (e) {
        console.error('Error parsing localStorage auth data', e);
      }

      return [];
    })(),






  ]

  const filterSidebar = (arrayList) => {
    return sidebarPayoad.filter((obj) => !arrayList.includes(obj.title))
  }
  // const payloadSidebar = isSponsor
  //   ? [
  //     {
  //       title: 'Plastic credits',
  //       route: '/apps/plastic-credits',
  //       icon: 'maximize',
  //       subMenu: [{ title: 'Retired', route: '/apps/plastic-credits/retired' }],
  //     },
  //   ]



  // const payloadSidebar = isSponsor
  //   ? [
  //     {
  //       title: 'Plastic Keepers',
  //       route: '/apps/Changemakers',
  //       icon: '/media/sideBarMenuIcon/change makers.png',
  //     },
  //     {
  //       title: 'Live Update',
  //       route: '/apps/impact-hub',
  //       icon: '/media/sideBarMenuIcon/impact hub sidemenu.png',
  //     },
  //     {
  //       title: 'Media toolkit',
  //       route: '/apps/mycommitments',
  //       icon: '/media/sideBarMenuIcon/commitment sidemenu.png',
  //     },
  //     {
  //       title: 'Certifications',
  //       route: '/apps/Certifications',
  //       icon: '/media/sideBarMenuIcon/commitment sidemenu.png',
  //     },
  //     {
  //       title: 'Contact (Main contact details - Live chat)',
  //       route: '/apps/Contact',
  //       icon: '/media/sideBarMenuIcon/commitment sidemenu.png',
  //     },
  //     // {
  //     //   title: 'Plastic credits',
  //     //   route: '/apps/plastic-credits',
  //     //   icon: '/media/sideBarMenuIcon/icons8-certificate-48.png',
  //     //   subMenu: [{ title: 'Retired', route: '/apps/plastic-credits/retired' }],
  //     // },
  //   ]
  //   : isAdmin
  //     ? [sidebarPayoad[0], sidebarPayoad[1], sidebarPayoad[2]]
  //     : isFacilityManager
  //       ? filterSidebar([
  //         'User Management',
  //         'Supply chain',
  //         // 'Supply chain',
  //         'Client',
  //         'Product passport',
  //         'Billing',
  //         'Monthly volume',
  //         'Settings',
  //         'Plastic credits',
  //       ])
  //       : isPartner
  //         ? filterSidebar(['Client', 'Product passport', 'Billing', 'Monthly volume'])
  //         : isFranchise || isSupplyChainManager
  //           ? filterSidebar([
  //       /* 'Settings', */ 'Client',
  //             'Supply chain',
  //             'Plastic credits',
  //             'Billing',
  //             'Monthly volume',
  //           ])
  //           : isAuditor
  //             ? [sidebarPayoad[9]]
  //             : [sidebarPayoad[8]]



  const payloadSidebar = isSponsor
    ? [
      {
        title: 'Sponsored hubs',
        route: '/apps/Changemakers',
        icon: '/media/sideBarMenuIcon/change makers.png',
      },
      {
        title: 'Live update',
        route: '/apps/impact-hub',
        icon: '/media/sideBarMenuIcon/impact hub sidemenu.png',
      },
      {
        title: 'Media toolkit',
        route: '/apps/mycommitments',
        icon: '/media/sideBarMenuIcon/MediaToolkit.png',
      },
      {
        title: 'My documents',
        route: '/apps/my-documents',
        icon: '/media/sideBarMenuIcon/MyDocument.png',
      },
      {
        title: 'Contact us',
        route: '/apps/contact-us',
        icon: '/media/sideBarMenuIcon/ContactUs.png',
      },
      // {
      //   title: 'Certifications',
      //   route: '/apps/Certifications',
      //   icon: '/media/sideBarMenuIcon/commitment sidemenu.png',
      // },
      ...(isSupplyChainManager ? [
        {
          title: 'Rewards',
          route: '/apps/rewards',
          icon: '/media/sideBarMenuIcon/rewards.png',
        }
      ] : []),
      // {
      //   title: 'Contact (Main contact details - Live chat)',
      //   route: '/apps/Contact',
      //   icon: '/media/sideBarMenuIcon/commitment sidemenu.png',
      // },
    ]
    : isAdmin
      ? [sidebarPayoad[0], sidebarPayoad[1], sidebarPayoad[2]]
      : isFacilityManager
        ? filterSidebar([
          'User management',
          'Supply chain',
          'Client',
          'Product passport',
          'Billing',
          'Monthly volume',
          'Settings',
          'Plastic credits',
        ])
        : isPartner
          ? filterSidebar(['Client', 'Product passport', 'Billing', 'Monthly volume'])
          : isFranchise || isSupplyChainManager
            ? filterSidebar([
              'Client',
              'Supply chain',
              'Plastic credits',
              'Billing',
              'Monthly volume',
            ])
              .concat([
                {
                  title: 'Rewards',
                  route: '/apps/rewards',
                  icon: '/media/sideBarMenuIcon/Facilities.png',
                }
              ])
            : isAuditor
              ? [sidebarPayoad[9]]
              : isMarketingUser
                ? [
                  {
                    title: 'Material Hubs',
                    route: 'apps/facility',
                    icon: '/media/sideBarMenuIcon/Facilities.png',
                  },
                  {
                    title: 'Plastic Keepers',
                    route: '/apps/waste-source',
                    icon: '/media/sideBarMenuIcon/sidebar waste supplier.png',
                  },
                ]
                : [sidebarPayoad[8]]


  return (
    <>
      {!isAuditor && (
        // <SidebarMenuItem
        //   to='/dashboard'
        //   // icon='element-11'
        //   icon='/media/sideBarMenuIcon/sidebar dashboard.png'
        //   // title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
        //   title={isSponsor ? 'My Impact' : intl.formatMessage({ id: 'MENU.DASHBOARD' })}
        //   fontIcon='bi-app-indicator'
        // />
        <SidebarMenuItem
          to={isSponsor ? '/My-impact' : '/dashboard'}
          icon='/media/sideBarMenuIcon/sidebar dashboard.png'
          title={isSponsor ? 'My Impact' : intl.formatMessage({ id: 'MENU.DASHBOARD' })}
          fontIcon='bi-app-indicator'
        />
      )}
      {!isAuditor && !isSponsor && (
        <>



          {/* <SidebarMenuItem
            to='/apps/leaderboard'
            // icon='parcel'
            icon='/media/sideBarMenuIcon/Sidebar analytics.png'
            title='Analytics'
            fontIcon='bi-layers'
          /> */}




          {/* 
          {currentUser.userType !== "PICKUP_POINT_STAFF" && (
            <SidebarMenuItem
              to='/apps/leaderboard'
              icon='/media/sideBarMenuIcon/Sidebar analytics.png'
              title='Analytics'
              fontIcon='bi-layers'
            />
          )} */}



          {/* {currentUser.userType !== "PICKUP_POINT_STAFF" && !isAdminUser && (
            <SidebarMenuItem
              to='/apps/leaderboard'
              icon='/media/sideBarMenuIcon/Sidebar analytics.png'
              title='Analytics'
              fontIcon='bi-layers'
            />
          )} */}
          {(currentUser.userType === "CLIENT" || currentUser.userType === "FRANCHISE_USER" || currentUser.userType === "CLIENT_USER" || currentUser.userType === "MARKETING") && (
            <SidebarMenuItem
              to='/apps/leaderboard'
              icon='/media/sideBarMenuIcon/Sidebar analytics.png'
              title={currentUser.userType === "CLIENT" ? 'Regional overview' : 'Supply chain'}
              fontIcon='bi-layers'
            />
          )}


          {/* {(currentUser.userType !== "PICKUP_POINT_STAFF" && !isAdminUser) && (
            <SidebarMenuItem
              to='/apps/leaderboard'
              icon='/media/sideBarMenuIcon/Sidebar analytics.png'
              title='Analytics'
              fontIcon='bi-layers'
            />
          )}

          {isAdminUser && (
            <SidebarMenuItem
              to='/apps/leaderboard'
              icon='/media/sideBarMenuIcon/Sidebar analytics.png'
              title='Collection Overview'
              fontIcon='bi-layers'
            />
          )} */}

          {/*       
          {JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}')?.data?.userType === "CLIENT" && (
            <SidebarMenuItem
              to='apps/makting'
              icon='/media/sideBarMenuIcon/icons8-pipeline-64.png'
              title='Maketing'
              fontIcon='bi-layers'
            />
          )} */}
          {/* {JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}')?.data?.userType === "CLIENT" && (
            <SidebarMenuItem
              to='apps/makting'
              icon='/media/sideBarMenuIcon/icons8-pipeline-64.png'
              title={
                <span>
                  Marketing
                  <span style={{
                    backgroundColor: '#dc3545',
                    color: 'white',
                    fontSize: '10px',
                    padding: '2px 6px',
                    borderRadius: '4px',
                    marginLeft: '8px',
                    fontWeight: '500',
                    verticalAlign: 'middle'
                  }}>
                    New
                  </span>
                </span>
              }
              fontIcon='bi-layers'
            />
          )} */}

          {/* {(JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}')?.data?.userType === "CLIENT" ||
            JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}')?.data?.userType === "CLIENT_USER") && (
              <>
                <SidebarMenuItem
                  to='apps/makting'
                  icon='/media/sideBarMenuIcon/icons8-pipeline-64.png'
                  title={
                    <span>
                      Marketing
                    </span>
                  }
                  fontIcon='bi-layers'
                />
                <SidebarMenuItem
                  to='/apps/business-development'
                  icon='/media/sideBarMenuIcon/icons8-pipeline-64.png'
                  title='Business Development'
                  fontIcon='bi-layers'
                />
              </>
            )} */}



          {JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}')?.data?.userType === "CLIENT" && (
            <SidebarMenuItem
              to='apps/makting'
              icon='/media/sideBarMenuIcon/icons8-pipeline-64.png'
              title={
                <span>
                  Marketing
                </span>
              }
              fontIcon='bi-layers'
            />
          )}

          {["CLIENT_USER"].includes(JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}')?.data?.userType) && (
            <SidebarMenuItem
              to='apps/makting'
              icon='/media/sideBarMenuIcon/icons8-pipeline-64.png'
              title={
                <span>
                  Marketing
                </span>
              }
              fontIcon='bi-layers'
            />
          )}
          {["CLIENT_USER", "MARKETING"].includes(JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}')?.data?.userType) &&
            <SidebarMenuItem
              to='/apps/business-development'
              icon='/media/sideBarMenuIcon/icons8-pipeline-64.png'
              title='Business development'
              fontIcon='bi-layers'
            />
          }

          {/* {isFranchise && (
            <SidebarMenuItem to='/apps/stock' icon='parcel' title='Stock' fontIcon='bi-layers' />
          )} */}
          {/*  <SidebarMenuItem
            to='/apps/monthly-reports'
            icon='parcel'
            title='Monthly Reports'
            fontIcon='bi-layers'
          />{' '} */}


          {/* <SidebarMenuItem to='/apps/reports'
            //  icon='parcel' 
            icon='/media/sideBarMenuIcon/sidebar reports.png'
            title='Reports'
            fontIcon='bi-layers' /> */}




          {/* {currentUser?.userType !== 'CLIENT' && (
            <SidebarMenuItem
              to='/apps/reports'
              icon='/media/sideBarMenuIcon/sidebar reports.png'
              title='Reports'
              fontIcon='bi-layers'
            />
          )} */}



          {/* {currentUser?.userType !== 'CLIENT' && !isAdminUser && (
            <SidebarMenuItem
              to='/apps/reports'
              icon='/media/sideBarMenuIcon/sidebar reports.png'
              title='Reports'
              fontIcon='bi-layers'
            />
          )} */}


          {/* {!isAdminUser && (
            <SidebarMenuItem
              to='/apps/reports'
              icon='/media/sideBarMenuIcon/sidebar reports.png'
              title='Reports'
              fontIcon='bi-layers'
            />
          )} */}
          {!isAdminUser && !isMarketingUser && (
            <SidebarMenuItem
              to='/apps/reports'
              icon='/media/sideBarMenuIcon/sidebar reports.png'
              title='Reports'
              fontIcon='bi-layers'
            />
          )}



          {/* {!isPartner && (
            <SidebarMenuItem to='/apps/impact'
              // icon='parcel'
              icon='/media/sideBarMenuIcon/side bar impact.png'
              title='Impact'
              fontIcon='bi-layers' />
          )} */}


          {/* {!isPartner && !isAdminUser && (
            <SidebarMenuItem to='/apps/impact'
              icon='/media/sideBarMenuIcon/side bar impact.png'
              title='Impact'
              fontIcon='bi-layers' />
          )} */}
          {/* {!isPartner && !isAdminUser && !isMarketingUser && (
            <SidebarMenuItem to='/apps/impact'
              icon='/media/sideBarMenuIcon/side bar impact.png'
              title='Impact'
              fontIcon='bi-layers' />
          )} */}


          {isSupplyChainManager && (
            <SidebarMenuItem
              to='/apps/price-analyser'
              // icon='parcel'
              icon='/media/sideBarMenuIcon/price.png'
              title='Price analyser'
              fontIcon='bi-layers'
            />
          )}
        </>
      )}
      {!isSponsor && (
        <div className='menu-item'>
          <div className='menu-content pt-8 pb-2'>
            <span className='menu-section text-dark  fs-8 ls-1'>Apps</span>
          </div>
        </div>
      )}

      {/* {payloadSidebar.map((sidebarName: any, index) => { */}

      {payloadSidebar
        .filter(item => !(isMarketingUser && item.title === 'Settings'))
        .map((sidebarName: any, index) => {
          return sidebarName?.subMenu?.length ? (
            <SidebarMenuItemWithSub
              key={index + 1 + ''}
              to={sidebarName.route}
              title={sidebarName.title}
              fontIcon='bi-layers'
              icon={sidebarName.icon}
            >
              {sidebarName?.subMenu.map((eachSubMenu, eachSubInd) => {
                return (
                  <SidebarMenuItem
                    key={eachSubInd + 1 + ''}
                    to={eachSubMenu.route}
                    title={eachSubMenu.title}
                    hasBullet={true}
                  />
                )
              })}
            </SidebarMenuItemWithSub>
          ) : (
            <SidebarMenuItem
              to={sidebarName.route}
              icon={sidebarName.icon}
              fontIcon='bi-layers'
              key={index + 1 + ''}
              title={sidebarName.title}
              hasBullet={sidebarName.hasBullet || false}
            />
          )
        })}
    </>
  )
}

export { SidebarMenuMain }
